export enum CFALocalizationTypes {
    Giveaway = 1,
    Sample
}